export const GlobalViewNames = Object.freeze({
    tracking: "tracking",
    media_monitoring: "media_monitoring",
    none: "none"
});



//////////////////
// WEBPACK FOOTER
// ./src/services/WellKnownGlobalViews.js
// module id = EcNE
// module chunks = 1